import {IAwsFormData} from '../api/api.types';
import {IAccessTokenApi} from '../api/access-token-api.service';
export interface IS3UploadService {
  uploadFileToS3(file:File):ng.IPromise<string>;
}

export default class S3UploadService implements IS3UploadService {
  static $inject = ['accessTokenApi', 'Upload'];

  constructor(private accessTokenApi:IAccessTokenApi,
              private uploadService:ng.angularFileUpload.IUploadService) {
  }

  uploadFileToS3(file:File):ng.IPromise<string> {
    return this.accessTokenApi.getAwsFormData().then((formData:IAwsFormData) => {
      formData.fields.key = `${formData.fields.key}/${file.name}`;
      const uploadData:any = <any>formData.fields;
      uploadData.file = file;
      uploadData['Content-Type'] = file.type;
      return this.uploadService.upload({
        url: formData.action,
        data: uploadData,
        method: 'POST'
      }).then(() => {
        return file.name;
      });
    });
  }

}



/** WEBPACK FOOTER **
 ** ./app/utils/s3-upload.service.ts
 **/